//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['event', 'statsURL', 'fixedMobile'],
  data() {
    return {
      tab: 'preview',
      showStream: false,
    }
  },
  computed: {
    stats() {
      return _.get(this.event, 'stats')
    },
    isMobile: {
      get() {
        return this.$store.state.isMobile
      },
    },
    isStreamingVisible: {
      get() {
        return _.get(this.$store.state, 'isStreamingVisible');
      },
      set(newValue) {
        this.$store.commit('setStreamingVisible', newValue)
      }
    },
    actuallyShowStream(){
      return (this.isTester || this.isCountryWhitelisted) && this.isStreamingVisible
    },
    isCountryWhitelisted(){
      return _.includes(_.get(this.event, 'stream.countries_whitelisted'), this.IPCountry);
    }
  },
  mounted() {
    if(this.isStreamingVisible && _.get(this.event, 'stream.provider') == 'img_arena'  && (this.isTester || this.isCountryWhitelisted) ) {
      this.playStream();
    }
  },
  methods: {
    openLiveStats() {
      if(this.tab != 'live') {
        this.tab = 'live'
      } else {
        this.tab = 'preview'
      }
    },
    openStats() {
      this.$store.commit('setStatId', this.event.id)
      this.$modal.show('modal-stats')
    },
    async toggleStream() {
      if(!this.showStream) {
        this.playerHeight = this.$refs['match-center'].clientHeight;
      }
      this.$store.commit('fixMatchWidget', !this.showStream)
      this.showStream = !this.showStream;
      this.isStreamingVisible = this.showStream;
    },
    async playStream() {
      this.showStream = true;
      this.isStreamingVisible = this.showStream;
    },
    async stopStream() {
      this.showStream = false;
      this.isStreamingVisible = this.showStream;
    },
  }
}
